import elementScrollPosition from './element-scroll-position';
import parentScrollPosition from './parent-scroll-position';

export default function (offsetParentElement, element) { return ( // eslint-disable-line no-arrow-condition
    offsetParentElement ? elementScrollPosition(offsetParentElement) : parentScrollPosition(element)
); };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/offset-parent-scroll-position.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/offset-parent-scroll-position.js
// module chunks = 3